import { render, staticRenderFns } from "./IconSvgMp3.vue?vue&type=template&id=46fc5054&scoped=true&"
import script from "./IconSvgMp3.vue?vue&type=script&lang=js&"
export * from "./IconSvgMp3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc5054",
  null
  
)

export default component.exports